import Repository from '../Repository';

export default {

	getMarkedFile(paperId) {
		var response = Repository.get('Mark/GetMarkedFile', {
			responseType: 'arraybuffer',
            headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/pdf'
            },					
			params: {
				paperId: paperId
			}
		});
		return response;
	},
	
	markCapture(paperId, mark, commentId) {
		var response = Repository.post('Mark/MarkCapture', {
			mark: mark,
			paperId: paperId,
			commentId: commentId
		});
		return response;
	},

	startMarking(paperId) {
		var response;
		response = Repository.put('Mark/StartMarking', {
			paperId: paperId
		});
		return response;	
	},

	getMarkCaptureAuditLogs(pageSize, pageNumber, searchString) {
		let payLoad = {params: {}};
		payLoad.params = { 
			pageSize: pageSize,
			pageNumber: pageNumber,
			SearchString: searchString,
			isActive: true,
			orderDirection: 'desc',
			SortBy: 'createTime', 
		}
		let response = Repository.get('Mark/GetMarkCaptureAuditLogs', payLoad);
		return response;
	},

}
